import { store } from '../..';
import axios from '../../plugins/axios';

export default function getDkpSignings(params = {}) {
  return axios.get('/api/signature/dkp', {
    params: {
      dcId: store?.getState()?.user?.dcId,
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      ...params,
    },
  });
} 